<div class="login2background" style="background-image: url(assets/img/global/fundo_login.jpg)">
  <div class="main-content container-fluid">
    <div class="splash-container">
      <div class="card">
        <div class="card-body">
          <form id="login-form" (ngSubmit)="f.form.valid" #f="ngForm" novalidate autocomplete="off"
            class="form-horizontal">

            <div class="row">
              <div class="col-8">
                <div class="row">
                  <div class="col-12">
                    <img src="assets/img/team.png" width="42" height="42" class="float-left">
                  </div>
                </div>
                <div class="row mb-5">
                  <div class="col-12">
                    <span class="font-weight-bold float-left">CRIE SUA CONTA</span><br>
                    <span class="font-weight-bold float-left text-black-50" style="font-size: 11px;">Novo
                      cadastro</span>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-5">
                    <input #nome [(ngModel)]="entidade.nome" style="font-weight: bold"
                      [ngClass]="{ 'is-invalid': f.submitted && nome.invalid }" required type="text"
                      class="form-control" name="nome" placeholder="Nome" id="nome">
                    <div *ngIf="f.submitted && nome.invalid" class="invalid-feedback">
                      <div *ngIf="nome.errors.required">Nome é requerido</div>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <input [(ngModel)]="entidade.sobrenome" #sobrenome
                      [ngClass]="{ 'is-invalid': f.submitted && sobrenome.invalid }" required type="text"
                      class="form-control" name="sobrenome" placeholder="Último nome" id="sobrenome">
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-10">
                    <input [(ngModel)]="entidade.email" #email
                      [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" required type="text"
                      class="form-control" name="email" placeholder="Seu e-mail para acesso ao sistema" id="email">
                    <small id="emailHelp" class="form-text text-muted">Você pode usar letras, números e pontos
                      finais</small>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-5">
                    <input [imask]="{mask: '000.000.000-00'}" unmask="true" [(ngModel)]="entidade.cpf" #cpf
                      [ngClass]="{ 'is-invalid': f.submitted && cpf.invalid }" required type="text" class="form-control"
                      name="cpf" placeholder="Número do seu CPF" id="cpf">
                  </div>
                  <div class="col-sm-5">
                    <input [imask]="{mask: [ {mask: '0000-0000'}, {mask: '00000-0000'}, {mask: '(00) 0000-0000'}, {mask: '(00) 00000-0000'} ]}" unmask="true" #fone
                      [(ngModel)]="entidade.telefone" [ngClass]="{ 'is-invalid': f.submitted && fone.invalid }" required
                      type="text" class="form-control" name="fone" placeholder="Telefone para contato" id="fone">
                  </div>
                </div>
                <div class="row mt-4 mb-4">
                  <div class="col-10">
                    <button (click)="registrar()" class="btn btn-primary btn-sm float-right">Enviar</button>
                    <button (click)="sair()" class="btn btn-link btn-sm float-right mr-3">Voltar para tela de
                      login</button>
                  </div>
                </div>
              </div>
              <div class="col-3 text-center mr-5 mt-5">
                <!-- <div class="marca-da-agua"></div> -->
                <img src="assets/img/buildings.png" width="160" height="160" style="opacity: 0.4;">
                <p style="font-weight: 100; font-size: 13px; text-align: justify;">Tenha acesso ao sistema integrado de
                  gestão pública EDDYDATA</p>
              </div>
            </div>
            <!-- <pre>{{ entidade | json}}</pre> -->
          </form>
        </div>
      </div>
    </div>
  </div>
</div>